<form #rehearsalForm="ngForm">

  <!-- Form Fields Section -->
  <div class="form-card">
    <div class="form-section">
      <label class="field-label">Ingevuld door *</label>
      <ion-input
        name="personName"
        [(ngModel)]="rehearsalRequest.personName"
        #personNameModel="ngModel"
        required
        [disabled]="isSaving"
        placeholder="Je naam"
        class="form-input"
      />
      @if (personNameModel.invalid && personNameModel.touched) {
        <span class="error-text">Dit veld is verplicht.</span>
      }
    </div>

    <div class="form-section">
      <label class="field-label">Repetitie voor</label>
      <ion-input
        name="purpose"
        [(ngModel)]="rehearsalRequest.purpose"
        #purposeModel="ngModel"
        maxlength="200"
        [disabled]="isSaving"
        placeholder="bv. Oscar en Eva 30"
        class="form-input"
      />
    </div>

    <div class="form-section">
      <label class="field-label">Opmerkingen</label>
      <ion-textarea
        name="notes"
        [(ngModel)]="rehearsalRequest.notes"
        #notesModel="ngModel"
        maxlength="1000"
        auto-grow="true"
        autocapitalize="sentences"
        rows="3"
        [disabled]="isSaving"
        placeholder="bv. Graag alles met tags"
        class="form-input"
      />
    </div>
  </div>

  <!-- Scene List -->
  <div class="scenes-card">
    <div class="card-header">
      <ion-icon name="list-outline"></ion-icon>
      <span>Scènes</span>
    </div>

    <div class="scenes-list">
      @for (scene of availableScenes; track scene.id) {
        <div
          class="scene-row"
          [class.selected]="isSceneRequired(scene)"
          (click)="toggleScene(scene)"
        >
          <ion-checkbox
            [disabled]="isSaving"
            [checked]="isSceneRequired(scene)"
          />
          <span class="scene-name">{{ scene.name }}</span>
        </div>

        <!-- Items within scene -->
        @if (scene.items && isSceneRequired(scene)) {
          <div class="scene-details">
            <div class="items-grid">
              @for (item of scene.items; track item.id) {
                <div
                  class="item-row"
                  [class.selected]="isItemRequired(scene, item)"
                  (click)="toggleItem(scene, item)"
                >
                  <ion-checkbox
                    [disabled]="isSaving"
                    [checked]="isItemRequired(scene, item)"
                  />
                  <span class="item-name">{{ item.name }}</span>
                </div>
              }
            </div>

            <div class="scene-notes-input">
              <label class="field-label-small">Notities voor deze scène</label>
              <ion-input
                [disabled]="isSaving"
                [(ngModel)]="scene.notes"
                [name]="'sceneNotes_' + scene.id"
                placeholder="bv. Geen water"
                class="form-input-small"
              />
            </div>
          </div>
        }
      }
    </div>
  </div>

  <!-- Scene Reordering Section -->
  @if (enableSceneReordering && rehearsalRequest.scenes.length > 0) {
    <div class="reorder-card">
      <div class="card-header">
        <ion-icon name="reorder-four-outline"></ion-icon>
        <span>Volgorde</span>
      </div>
      <p class="helper-text">Sleep om de volgorde aan te passen</p>
      <ion-reorder-group [disabled]="isSaving" (ionItemReorder)="handleSceneReorder($any($event))">
        @for (scene of rehearsalRequest.scenes; track scene.id) {
          <ion-item class="reorder-item">
            <ion-label>{{ scene.name }}</ion-label>
            <ion-reorder slot="end"></ion-reorder>
          </ion-item>
        }
      </ion-reorder-group>
    </div>
  }

  <!-- Summary Section -->
  @if (showSummary) {
    <div class="summary-card">
      <div class="card-header">
        <ion-icon name="document-text-outline"></ion-icon>
        <span>Overzicht</span>
      </div>
      <app-rehearsal-summary [rehearsal]="rehearsalRequest" [showHeader]="false" />
    </div>
  }

  <!-- Save Button -->
  <ion-button
    expand="block"
    class="save-button"
    [class.visually-disabled]="!isFormValid()"
    (click)="onSaveClick()"
    [disabled]="isSaving"
  >
    @if (isSaving) {
      <ion-spinner name="crescent" slot="start" />
    } @else {
      <ion-icon slot="start" name="checkmark-circle-outline"></ion-icon>
    }
    {{ isEditMode ? 'Repetitie Bijwerken' : 'Repetitie Opslaan' }}
  </ion-button>

</form>
